module.exports = __webpack_public_path__ + "static/media/linkedin.3702fc12.svg";